var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sensor-autocomplete',{attrs:{"id":"sensores","name":"sensores","local-id":_vm.localId,"required":true},model:{value:(_vm.sensorId),callback:function ($$v) {_vm.sensorId=$$v},expression:"sensorId"}})}
var staticRenderFns = []

export { render, staticRenderFns }